export interface UserDetails{
    createdBy?: string,
    createdByUserId?: string,
    updatedBy?: string,
    updatedByUserId?: string
}

export function defaultUserDetails() : UserDetails
{
    return {
        createdBy:'1',
        createdByUserId: 'TEST',
        updatedBy:'1',
        updatedByUserId: 'TEST'
    }
}

export interface UserProfile{
    id: string,
    firstName:string,
    lastName: string,
    displayName:string,
    emailId: string,
    isParticipant:boolean,
    province:string
}

export function UserProfileDefaultValues():UserProfile
{
    return {id:'',firstName:'',lastName:'',displayName:'',emailId:'',isParticipant:false,province:''}
}
